import axios from 'axios'
import store from '../store'
import {Message} from 'element-ui'

// 统一配置
let BOOKMARK_REQUEST = axios.create({
  baseURL:'https://navicat.xywfh.com',
  // baseURL:'http://localhost:8099',
  responseType: 'json',
  validateStatus (status) {
    // 200 外的状态码都认定为失败
    return status === 200
  }
})

BOOKMARK_REQUEST.interceptors.request.use((config) => {
  // 有 token就带上
  if (store.state.token) {
    config.headers.Authentication = store.state.token
  }

  return config
}, (error) => {
  return Promise.reject(error)
})

// 拦截响应
BOOKMARK_REQUEST.interceptors.response.use((config) => {
  if (!config || !config.data) {
    return config
  }
  let status = config.data.success
  if (status) {
    return config.data
  }else{
    return config
  }
}, (error) => {
  if (error.response) {
    let errorMessage = error.response.data === null ? '系统内部异常，请联系网站管理员' : error.response.data.message
    switch (error.response.status) {
      case 404:
        Message.error({
          message: '系统提示',
          description: '很抱歉，资源未找到',
          duration: 4
        })
        break
      case 403:
      case 401:
        Message.warn({
          message: '系统提示',
          description: '很抱歉，您无法访问该资源，可能是因为没有相应权限或者登录已失效',
          duration: 4
        })
        break
      default:
        Message.error({
          message: '系统提示',
          description: errorMessage,
          duration: 4
        })
        break
    }
  }
  return Promise.reject(error)
})


function paramsTranslate (param, key) {
  var paramStr = "";
  if (typeof (param) == 'string' || typeof (param) == 'number' || typeof (param) == 'boolean') {
    return encodeURIComponent(key) + "=" + encodeURIComponent(param) + "&";
  } else {
    var data = null;
    if (key) {
      if (typeof (param) == 'object') {
        data = param
      } else {
        data = param ? param[key] : ""
      }
    } else {
      data = param
    }

    for (var keyTemp in data) {
      var dataTemp = data[keyTemp];

      if(data instanceof Array) {
        if(key){
          keyTemp = key + '[' + keyTemp + ']'
        }
      }else if(!!data && data instanceof Object){
        if(key) {
          keyTemp = key + '.' + keyTemp
        }
      }
      paramStr += paramsTranslate(dataTemp, keyTemp);
    }
  }
  return paramStr;
}

const request = {
  get (url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return BOOKMARK_REQUEST.get(`${url}${_params}`)
  },
  post(url, params = {}) {
    return BOOKMARK_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        // let data = paramsTranslate(params)
        let data = JSON.stringify(params)
        return data
      }],
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
        'Content-Type': 'application/json'
      }
    })
  },
  downloadFile(url, downFileName) {
    return BOOKMARK_REQUEST.get(url, {
      responseType: 'blob'
    }).then(
      function (response) {
        var blob = new Blob([response.data])
        var downloadElement = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = downFileName || (new Date()).getTime(); //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(function (error) {
      // console.log(error);
    })
  }
}
export default request
